module.exports = __webpack_public_path__ + "media/images/icon-cash-off@3x-bd38dbd64bfbf1f62f76ad406ca37067.png";